import React, { useEffect, useState, useRef, } from 'react';
import classNames from 'classnames';
import MenuButton from './MenuButton';
import { validateColorPreset } from '../../utils/presetValidator';
import '../../css/smallButton.css';
// Custom hook for getting previous prop value
function usePrevious(value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
}
var SmallButton = function (props) {
    var _a, _b;
    var className = props.className, color = props.color, disabled = props.disabled, forceCloseBool = props.forceCloseBool, forceCloseFunc = props.forceCloseFunc, hidden = props.hidden, id = props.id, menuButtons = props.menuButtons, leftHandedMenu = props.leftHandedMenu, onClick = props.onClick;
    var prevForceCloseBool = usePrevious(forceCloseBool);
    var _c = useState(false), isOpen = _c[0], toggleOpen = _c[1];
    var _d = useState(color), _color = _d[0], setColor = _d[1];
    useEffect(function () {
        if (color !== undefined && validateColorPreset(color)) {
            setColor(color);
        }
    }, [color]);
    useEffect(function () {
        if (prevForceCloseBool === false && forceCloseBool === true) {
            toggleOpen(false);
            forceCloseFunc(false);
        }
    }, [forceCloseBool, prevForceCloseBool, forceCloseFunc]);
    var _clickHandler = function (e) {
        e.stopPropagation();
        if (!disabled && !hidden) {
            toggleOpen(!isOpen);
            if (typeof onClick === 'function') {
                onClick(e);
            }
        }
    };
    var _mouseUpHandler = function (e) {
        if (isOpen) {
            e.currentTarget.blur();
        }
    };
    var _containerClassName = classNames('small-button', {
        'small-button--hidden': hidden,
        'small-button--disabled': disabled,
    });
    var _buttonClassName = classNames('small-button__button', className, (_a = {
            'small-button__button--clydeBlue': !_color
        },
        _a["small-button__button--".concat(_color)] = _color,
        _a['small-button__button--open'] = isOpen,
        _a));
    var _arrowClassName = classNames('small-button__button__arrow', (_b = {
            'small-button__button__arrow--clydeBlue': !_color
        },
        _b["small-button__button__arrow--".concat(_color)] = _color,
        _b['small-button__button__arrow--open'] = isOpen,
        _b));
    var _menuClassName = classNames('small-button-menu', {
        'small-button-menu--right': !leftHandedMenu,
        'small-button-menu--left': leftHandedMenu,
    });
    var menu = menuButtons || [];
    return (React.createElement("div", { className: _containerClassName },
        React.createElement("button", { className: _buttonClassName, disabled: disabled || hidden, id: id || '', onClick: _clickHandler, onMouseUp: _mouseUpHandler },
            React.createElement("div", { className: _arrowClassName })),
        isOpen
            && React.createElement("ul", { className: _menuClassName }, menu.map(function (menuButton, idx) { return (React.createElement(MenuButton, { key: "small-button-menu-button-".concat(idx), _buttonDisabled: menuButton.disabled, _menuHidden: hidden, label: menuButton.label, _menuDisabled: disabled, onClick: menuButton.onClick, showButton: menuButton.showButton })); }))));
};
export default SmallButton;
